import React, {Component} from 'react';
import EditUserPage from './EditUserPage';
import GreenLeafApi from '../utils/GreenLeafApi';

class InviteUser extends Component {

  inviteUser = async (user) => {
    let params = {
      Username: user.email,
      UserAttributes: [
        {
          Name: 'custom:first_name',
          Value: user.first_name
        },
        {
          Name: 'custom:last_name',
          Value: user.last_name
        },
        {
          Name: 'custom:role',
          Value: user.role
        },
        {
          Name: 'email',
          Value: user.email
        },
        {
          Name: 'email_verified',
          Value: 'True'
        }
      ],
      DesiredDeliveryMediums: ['EMAIL']
    };

    try {
      await GreenLeafApi.User.inviteUser(params);

      user.companies.forEach(async o => {
        await GreenLeafApi.CompanyUser.create({ company_id: o.value, user_email: user.email });
      });
    } catch (e) {
      throw new Error(e);
    }
  };

  render() {
    return (
      <div>
        <EditUserPage
          isInviting
          inviteUser={this.inviteUser}/>
      </div>
    );
  }
}

export default InviteUser;



// WEBPACK FOOTER //
// ./src/components/user/InviteUser.js